var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { staticClass: "statistics-cards mb20", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card total-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-user" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.statistics.totalMembers ||
                        _vm.statistics.totalUsers ||
                        0
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("会员总数")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card active-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-check" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.statistics.activeMembers ||
                        _vm.statistics.activeUsers ||
                        0
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("活跃会员")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card male-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-male" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.statistics.maleMembers ||
                        _vm.statistics.maleUsers ||
                        0
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("男性会员")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card female-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-female" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.statistics.femaleMembers ||
                        _vm.statistics.femaleUsers ||
                        0
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("女性会员")]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card union-card" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "back-btn",
                    attrs: { size: "mini", icon: "el-icon-back" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  },
                  [_vm._v("返回")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "title-content" },
                  [
                    _c("i", { staticClass: "el-icon-user title-icon" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("工会会员管理")]),
                    _vm._v(" "),
                    _vm.unionName
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "ml10",
                            attrs: { type: "success", size: "mini" },
                          },
                          [
                            _c("i", { staticClass: "el-icon-office-building" }),
                            _vm._v(
                              " " + _vm._s(_vm.unionName) + "\n          "
                            ),
                          ]
                        )
                      : _c(
                          "el-tag",
                          {
                            staticClass: "ml10",
                            attrs: { type: "warning", size: "mini" },
                          },
                          [
                            _c("i", { staticClass: "el-icon-warning" }),
                            _vm._v(" 未选择工会\n          "),
                          ]
                        ),
                    _vm._v(" "),
                    _vm.deptId
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "ml10",
                            attrs: {
                              type: "info",
                              size: "mini",
                              effect: "plain",
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-postcard" }),
                            _vm._v(
                              " ID: " + _vm._s(_vm.deptId) + "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-tag",
                      {
                        staticClass: "ml10",
                        attrs: { size: "mini", effect: "plain" },
                      },
                      [
                        _vm._v(
                          "共 " + _vm._s(_vm.listData.total || 0) + " 条记录"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "action-btn",
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openEdit()
                      },
                    },
                  },
                  [_vm._v("\n          新增会员\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    staticClass: "action-dropdown",
                    attrs: { size: "small" },
                    on: { command: _vm.handleBatchAction },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "action-btn",
                        attrs: { size: "small", icon: "el-icon-more" },
                      },
                      [
                        _vm._v("\n            批量操作"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchDelete" } },
                          [
                            _c("i", { staticClass: "el-icon-delete" }),
                            _vm._v(" 批量删除"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchEnable" } },
                          [
                            _c("i", { staticClass: "el-icon-check" }),
                            _vm._v(" 批量启用"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchDisable" } },
                          [
                            _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" 批量禁用"),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    staticClass: "action-dropdown",
                    attrs: { size: "small" },
                    on: { command: _vm.handleImportExport },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "action-btn",
                        attrs: { size: "small", icon: "el-icon-download" },
                      },
                      [
                        _vm._v("\n            导入导出"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "export" } },
                          [
                            _c("i", { staticClass: "el-icon-download" }),
                            _vm._v(" 导出数据"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "template" } },
                          [
                            _c("i", { staticClass: "el-icon-document" }),
                            _vm._v(" 下载模板"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "import" } },
                          [
                            _c("i", { staticClass: "el-icon-upload2" }),
                            _vm._v(" 导入数据"),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    staticClass: "action-dropdown",
                    attrs: { size: "small" },
                    on: { command: _vm.handleSyncAction },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "action-btn",
                        attrs: {
                          size: "small",
                          icon: "el-icon-refresh",
                          loading: _vm.syncLoading,
                        },
                      },
                      [
                        _vm._v("\n            数据同步"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "syncUnionUser" } },
                          [
                            _c("i", { staticClass: "el-icon-user" }),
                            _vm._v(" 同步会员数据\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "syncUnionBase" } },
                          [
                            _c("i", { staticClass: "el-icon-office-building" }),
                            _vm._v(" 同步工会信息\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "fullSync" } },
                          [
                            _c("i", { staticClass: "el-icon-refresh" }),
                            _vm._v(" 全量同步\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { divided: "", command: "goToSyncPage" } },
                          [
                            _c("i", { staticClass: "el-icon-setting" }),
                            _vm._v(" 高级同步设置\n            "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "action-btn",
                    attrs: { size: "small", icon: "el-icon-refresh-right" },
                    on: { click: _vm.refreshData },
                  },
                  [_vm._v("刷新")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "action-btn",
                    attrs: { size: "small", icon: "el-icon-setting" },
                    on: {
                      click: function ($event) {
                        _vm.columnVisible = true
                      },
                    },
                  },
                  [_vm._v("列设置")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              staticClass: "filter-collapse",
              model: {
                value: _vm.filterCollapse,
                callback: function ($$v) {
                  _vm.filterCollapse = $$v
                },
                expression: "filterCollapse",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "高级筛选", name: "1" } },
                [
                  _c("div", { staticClass: "filter-header" }, [
                    _c("i", { staticClass: "el-icon-search" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("筛选条件")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      staticClass: "filter-form",
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "80px",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "关键词搜索" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "账号/昵称/姓名/手机号",
                                clearable: "",
                                "prefix-icon": "el-icon-search",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.doSearch($event)
                                },
                              },
                              model: {
                                value: _vm.query.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "keyword", $$v)
                                },
                                expression: "query.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: { click: _vm.doSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "用户账号",
                              clearable: "",
                              "prefix-icon": "el-icon-user",
                            },
                            model: {
                              value: _vm.query.account,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "account", $$v)
                              },
                              expression: "query.account",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "真实姓名",
                              clearable: "",
                              "prefix-icon": "el-icon-user-solid",
                            },
                            model: {
                              value: _vm.query.realName,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "realName", $$v)
                              },
                              expression: "query.realName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.query.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "sex", $$v)
                                },
                                expression: "query.sex",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 0, label: "未知" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 1, label: "男" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 2, label: "女" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 3, label: "保密" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "手机号",
                              clearable: "",
                              "prefix-icon": "el-icon-phone",
                            },
                            model: {
                              value: _vm.query.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "phone", $$v)
                              },
                              expression: "query.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "邮箱地址",
                              clearable: "",
                              "prefix-icon": "el-icon-message",
                            },
                            model: {
                              value: _vm.query.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "email", $$v)
                              },
                              expression: "query.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.query.userType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "userType", $$v)
                                },
                                expression: "query.userType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 1, label: "普通会员" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 2, label: "VIP会员" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 3, label: "管理员" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活跃状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.query.isActive,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "isActive", $$v)
                                },
                                expression: "query.isActive",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: true, label: "活跃用户" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: false, label: "非活跃用户" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年龄段" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.query.ageRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "ageRange", $$v)
                                },
                                expression: "query.ageRange",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 1, label: "18-25岁" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 2, label: "26-35岁" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 3, label: "36-45岁" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 4, label: "46-55岁" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 5, label: "55岁以上" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth",
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              "unlink-panels": "",
                              "picker-options":
                                (_vm.$timeOptions &&
                                  _vm.$timeOptions.datePickerOptions) ||
                                {},
                            },
                            model: {
                              value: _vm.query.dateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "dateRange", $$v)
                              },
                              expression: "query.dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "注册时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth",
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "注册开始",
                              "end-placeholder": "注册结束",
                              "value-format": "yyyy-MM-dd",
                              "unlink-panels": "",
                              "picker-options":
                                (_vm.$timeOptions &&
                                  _vm.$timeOptions.datePickerOptions) ||
                                {},
                            },
                            model: {
                              value: _vm.query.registerTimeRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "registerTimeRange", $$v)
                              },
                              expression: "query.registerTimeRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.doSearch },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-refresh" },
                              on: { click: _vm.resetSearch },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.unionId && !_vm.deptId
            ? _c(
                "el-alert",
                {
                  staticClass: "mb20",
                  attrs: {
                    title: "请先选择工会",
                    type: "warning",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    [
                      _vm._v(
                        '\n        您还没有选择工会，请先到工会信息页面选择要管理的工会，然后点击"会员"按钮进入会员管理。\n        '
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ml10",
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                "/systemSetting/userSetting/union"
                              )
                            },
                          },
                        },
                        [_vm._v("\n          前往工会列表\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "mt10 enhanced-table",
                  attrs: {
                    data: _vm.listData.list,
                    size: "mini",
                    "header-cell-style": {
                      fontWeight: "bold",
                      background: "#f5f7fa",
                    },
                    stripe: "",
                    "row-key": "id",
                    "element-loading-text": "加载中...",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255, 255, 255, 0.8)",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _vm.visibleColumns.id
                    ? _c("el-table-column", {
                        attrs: { prop: "id", label: "ID", width: "80" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.avatar
                    ? _c("el-table-column", {
                        attrs: { label: "头像", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "avatar-container" },
                                    [
                                      _c(
                                        "el-avatar",
                                        {
                                          staticClass: "user-avatar",
                                          attrs: {
                                            size: 36,
                                            src: scope.row.avatar,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-user-solid",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1439668291
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.account
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "account",
                          label: "账号",
                          "min-width": "140",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "account-cell" }, [
                                    _c(
                                      "span",
                                      { staticClass: "account-text" },
                                      [_vm._v(_vm._s(scope.row.account))]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1143968272
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.name
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "昵称",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "nickname-text" }, [
                                    _vm._v(_vm._s(scope.row.name || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3192058962
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.real_name
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "real_name",
                          label: "姓名",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "realname-text" }, [
                                    _vm._v(_vm._s(scope.row.real_name || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1045942690
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.phone
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "phone",
                          label: "手机",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "phone-text" }, [
                                    _vm._v(_vm._s(scope.row.phone || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1639970013
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.email
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "email",
                          label: "邮箱",
                          "min-width": "180",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "email-text" }, [
                                    _vm._v(_vm._s(scope.row.email || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2934560861
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.sex
                    ? _c("el-table-column", {
                        attrs: { prop: "sex", label: "性别", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getSexTagType(scope.row.sex),
                                        size: "mini",
                                        effect: "plain",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.formatSex(scope.row.sex)) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2012927580
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visibleColumns.created_at
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "created_at",
                          label: "创建时间",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "time-text" }, [
                                    _vm._v(_vm._s(scope.row.created_at || "-")),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3360795490
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "160",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "action-buttons-icon" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "查看详情",
                                      placement: "top",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "action-icon-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        icon: "el-icon-view",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDetail(scope.row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "编辑会员",
                                      placement: "top",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "action-icon-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        icon: "el-icon-edit",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openEdit(scope.row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "删除会员",
                                      placement: "top",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "action-icon-btn",
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.doDelete(scope.row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("template", { slot: "empty" }, [
                    _c("div", { staticClass: "empty-state" }, [
                      _c("i", { staticClass: "el-icon-user empty-icon" }),
                      _vm._v(" "),
                      _vm.unionId || _vm.deptId
                        ? _c("p", { staticClass: "empty-text" }, [
                            _vm._v("该工会暂无会员数据"),
                          ])
                        : _c("p", { staticClass: "empty-text" }, [
                            _vm._v("暂无会员数据"),
                          ]),
                      _vm._v(" "),
                      _vm.unionId || _vm.deptId
                        ? _c("p", { staticClass: "empty-desc" }, [
                            _vm._v(
                              "您可以新增会员，或者从其他渠道导入会员信息"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "empty-actions" },
                        [
                          _vm.unionId || _vm.deptId
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEdit()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _vm._v(" 新增会员\n              "),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.unionId || _vm.deptId
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.importVisible = true
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-upload" }),
                                  _vm._v(" 导入会员\n              "),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticClass: "mt10 enhanced-pagination",
            attrs: {
              "current-page": _vm.query.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "enhanced-dialog",
          attrs: {
            title: _vm.editDialogTitle,
            visible: _vm.editDialog.visible,
            width: "900px",
            "before-close": _vm.closeEdit,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              staticClass: "enhanced-form",
              attrs: {
                model: _vm.editDialog.form,
                rules: _vm.editRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账号", prop: "account" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              placeholder: "请输入账号",
                            },
                            model: {
                              value: _vm.editDialog.form.account,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "account", $$v)
                              },
                              expression: "editDialog.form.account",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.editDialog.isCreate
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "密码", prop: "password" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "255",
                                  type: "password",
                                  placeholder: "请输入密码",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.editDialog.form.password,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editDialog.form,
                                      "password",
                                      $$v
                                    )
                                  },
                                  expression: "editDialog.form.password",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "昵称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              placeholder: "请输入昵称",
                            },
                            model: {
                              value: _vm.editDialog.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "name", $$v)
                              },
                              expression: "editDialog.form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名", prop: "real_name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              placeholder: "请输入真实姓名",
                            },
                            model: {
                              value: _vm.editDialog.form.real_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "real_name", $$v)
                              },
                              expression: "editDialog.form.real_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机", prop: "phone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "20",
                              placeholder: "请输入手机号",
                            },
                            model: {
                              value: _vm.editDialog.form.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "phone", $$v)
                              },
                              expression: "editDialog.form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "100",
                              placeholder: "请输入邮箱地址",
                            },
                            model: {
                              value: _vm.editDialog.form.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "email", $$v)
                              },
                              expression: "editDialog.form.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别", prop: "sex" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择性别" },
                              model: {
                                value: _vm.editDialog.form.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editDialog.form, "sex", $$v)
                                },
                                expression: "editDialog.form.sex",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 0, label: "未知" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 1, label: "男" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 2, label: "女" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 3, label: "保密" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "头像" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-row" },
                          [
                            _c(
                              "el-avatar",
                              {
                                staticClass: "mr10",
                                attrs: {
                                  size: 50,
                                  src: _vm.editDialog.form.avatar,
                                },
                              },
                              [_c("i", { staticClass: "el-icon-user-solid" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  plain: "",
                                },
                                on: { click: _vm.pickAvatar },
                              },
                              [_vm._v("选择头像")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeEdit } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.editDialog.loading },
                  on: { click: _vm.submitEdit },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.editDialog.loading ? "保存中..." : "保存") +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "enhanced-dialog detail-dialog",
          attrs: {
            title: "会员详情",
            visible: _vm.detailDialog.visible,
            width: "900px",
            "before-close": _vm.closeDetail,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.detailDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "detail-form" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v("\n            基本信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(" 用户ID"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.id || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" 账号"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.account || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-star-off" }),
                        _vm._v(" 昵称"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.name || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                        _vm._v(" 真实姓名"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.realName || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-phone" }),
                        _vm._v(" 手机号码"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.phone || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-message" }),
                        _vm._v(" 邮箱地址"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.email || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-male" }),
                        _vm._v(" 性别"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detailDialog.data.sexDesc ||
                              _vm.formatSex(_vm.detailDialog.data.sex)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-postcard" }),
                        _vm._v(" 身份证号"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detailDialog.data.identificationNumber || "-"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-office-building" }),
                      _vm._v("\n            工会信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-office-building" }),
                        _vm._v(" 所属工会"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.unionName || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-medal" }),
                        _vm._v(" 用户类型"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.userTypeDesc || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-picture-outline" }),
                        _vm._v(" 头像"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("el-avatar", {
                            attrs: {
                              size: 50,
                              src: _vm.detailDialog.data.avatar,
                              icon: "el-icon-user",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-switch-button" }),
                        _vm._v(" 账户状态"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.detailDialog.data.status === 1
                                    ? "success"
                                    : "danger",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.detailDialog.data.status === 1
                                      ? "启用"
                                      : "禁用"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v("\n            时间信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" 创建时间"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.createdAt || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-edit" }),
                        _vm._v(" 更新时间"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.updatedAt || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v(" 最后登录时间"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.lastLoginTime || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-data-line" }),
                        _vm._v(" 登录次数"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v(
                              _vm._s(_vm.detailDialog.data.loginCount || 0) +
                                " 次"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.detailDialog.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "enhanced-dialog column-dialog",
          attrs: {
            title: "列设置",
            visible: _vm.columnVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.columnVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "column-settings" },
            [
              _c(
                "el-alert",
                {
                  staticClass: "mb20",
                  attrs: {
                    title: "选择要显示的表格列",
                    type: "info",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    [
                      _vm._v(
                        "\n          拖拽可调整列的显示顺序，取消勾选可隐藏对应列\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "column-checkboxes",
                  model: {
                    value: _vm.selectedColumns,
                    callback: function ($$v) {
                      _vm.selectedColumns = $$v
                    },
                    expression: "selectedColumns",
                  },
                },
                _vm._l(_vm.columnOptions, function (label, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "column-item" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "column-checkbox",
                          attrs: { label: key },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-menu column-drag-handle",
                          }),
                          _vm._v(
                            "\n            " + _vm._s(label) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.columnVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveColumnSettings },
                },
                [_vm._v("保存设置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "enhanced-dialog import-dialog",
          attrs: {
            title: "导入会员信息",
            visible: _vm.importVisible,
            width: "700px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "import-content" },
            [
              _c(
                "div",
                { staticClass: "import-steps" },
                [
                  _c(
                    "el-steps",
                    {
                      staticClass: "mb20",
                      attrs: { active: 1, "finish-status": "success" },
                    },
                    [
                      _c("el-step", {
                        attrs: {
                          title: "下载模板",
                          description: "获取标准格式",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-step", {
                        attrs: {
                          title: "填写数据",
                          description: "按模板要求填写",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-step", {
                        attrs: {
                          title: "上传文件",
                          description: "导入会员信息",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-alert",
                {
                  staticClass: "mb20",
                  attrs: {
                    title: "导入说明",
                    type: "info",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    [
                      _c("ul", { staticClass: "import-rules" }, [
                        _c("li", [
                          _c("i", { staticClass: "el-icon-document" }),
                          _vm._v(" 请先下载导入模板，按照模板格式填写数据"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "el-icon-files" }),
                          _vm._v(" 支持Excel格式文件（.xlsx, .xls）"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "el-icon-warning" }),
                          _vm._v(" 每次最多导入1000条记录"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "el-icon-key" }),
                          _vm._v(" 账号和手机号必须唯一"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" 密码字段为新增时必填，编辑时可留空"),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "import-actions" },
                [
                  _c(
                    "div",
                    { staticClass: "template-download" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "info",
                            icon: "el-icon-download",
                            plain: "",
                            size: "medium",
                          },
                          on: { click: _vm.downloadTemplate },
                        },
                        [_vm._v("\n            下载导入模板\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "template-tip" }, [
                        _vm._v("建议先下载模板了解数据格式"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider", [_vm._v("或")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "file-upload" },
                    [
                      _c(
                        "ButtonUploadExcel",
                        { attrs: { beforeUpload: _vm.beforeImport } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-upload",
                                size: "medium",
                              },
                            },
                            [
                              _vm._v(
                                "\n              选择Excel文件\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload-tip" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(
                          "\n            支持 .xlsx 和 .xls 格式，文件大小不超过10MB\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }